import { ROUTES } from 'views/Configure/stubs';

const BASE_URL = ROUTES.REFUND_METHODS;

export default {
  CONFIGURE: ROUTES.HOME,
  RETURN_MANAGEMENT: ROUTES.RETURN_MANAGEMENT,
  HOME: BASE_URL,
  REFUND_METHOD_DETAILS_EDIT: `${BASE_URL}/:id`
  // REFUND_METHOD_DETAILS: `${BASE_URL}/:id`
};
